import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryItem } from '../../../domain/dictionary.model';

@Pipe({
    name: 'onlyEstimate'
})
export class OnlyEstimatePipe implements PipeTransform {
    transform(value: DictionaryItem[], onlyAso: boolean): any {
        console.log(onlyAso);
        if (onlyAso === false) {
            return value;
        }
        return (value || []).filter(v => v.code === 'ESTIMATE');
    }
}
